/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Freebies_Meta_TitleInputs */

const id_freebies_meta_title = /** @type {(inputs: Freebies_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Game Gratis | egdata.app`)
};

const ms_freebies_meta_title = /** @type {(inputs: Freebies_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permainan Percuma | egdata.app`)
};

const da_freebies_meta_title = /** @type {(inputs: Freebies_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis Spil | egdata.app`)
};

const de_freebies_meta_title = /** @type {(inputs: Freebies_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenlose Spiele | egdata.app`)
};

const en_us2_freebies_meta_title = /** @type {(inputs: Freebies_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free Games | egdata.app`)
};

const es_es2_freebies_meta_title = /** @type {(inputs: Freebies_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juegos gratis | egdata.app`)
};

const es_mx2_freebies_meta_title = /** @type {(inputs: Freebies_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juegos gratis | egdata.app`)
};

const fil_freebies_meta_title = /** @type {(inputs: Freebies_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Libreng Laro | egdata.app`)
};

const fr_freebies_meta_title = /** @type {(inputs: Freebies_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeux gratuits | egdata.app`)
};

const it_freebies_meta_title = /** @type {(inputs: Freebies_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giochi Gratis | egdata.app`)
};

const hu_freebies_meta_title = /** @type {(inputs: Freebies_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingyenes játékok | egdata.app`)
};

const nl_freebies_meta_title = /** @type {(inputs: Freebies_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis Games | egdata.app`)
};

const no_freebies_meta_title = /** @type {(inputs: Freebies_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis spill | egdata.app`)
};

const pl_freebies_meta_title = /** @type {(inputs: Freebies_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Darmowe gry | egdata.app`)
};

const pt_br2_freebies_meta_title = /** @type {(inputs: Freebies_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogos grátis | egdata.app`)
};

const pt_freebies_meta_title = /** @type {(inputs: Freebies_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogos Grátis | egdata.app`)
};

const ro_freebies_meta_title = /** @type {(inputs: Freebies_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jocuri gratuite | egdata.app`)
};

const fi_freebies_meta_title = /** @type {(inputs: Freebies_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilmaiset pelit | egdata.app`)
};

const sv_freebies_meta_title = /** @type {(inputs: Freebies_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis spel | egdata.app`)
};

const vi_freebies_meta_title = /** @type {(inputs: Freebies_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Game miễn phí | egdata.app`)
};

const tr_freebies_meta_title = /** @type {(inputs: Freebies_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ücretsiz Oyunlar | egdata.app`)
};

const cs_freebies_meta_title = /** @type {(inputs: Freebies_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hry zdarma | egdata.app`)
};

const bg_freebies_meta_title = /** @type {(inputs: Freebies_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Безплатни игри | egdata.app`)
};

const ru_freebies_meta_title = /** @type {(inputs: Freebies_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бесплатные игры | egdata.app`)
};

const uk_freebies_meta_title = /** @type {(inputs: Freebies_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Безкоштовні ігри | egdata.app`)
};

const ar_freebies_meta_title = /** @type {(inputs: Freebies_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الألعاب المجانية | egdata.app`)
};

const hi_freebies_meta_title = /** @type {(inputs: Freebies_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मुफ़्त गेम | egdata.app`)
};

const th_freebies_meta_title = /** @type {(inputs: Freebies_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกมฟรี | egdata.app`)
};

const ja_freebies_meta_title = /** @type {(inputs: Freebies_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料ゲーム | egdata.app`)
};

const zh_cn2_freebies_meta_title = /** @type {(inputs: Freebies_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费游戏 | egdata.app`)
};

const zh_hant1_freebies_meta_title = /** @type {(inputs: Freebies_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免費遊戲 | egdata.app`)
};

const ko_freebies_meta_title = /** @type {(inputs: Freebies_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무료 게임 | egdata.app`)
};

/**
* | output |
* | --- |
* | "Free Games \| egdata.app" |
*
* @param {Freebies_Meta_TitleInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const freebies_meta_title = /** @type {((inputs?: Freebies_Meta_TitleInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Freebies_Meta_TitleInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_freebies_meta_title(inputs)
	if (locale === "ms") return ms_freebies_meta_title(inputs)
	if (locale === "da") return da_freebies_meta_title(inputs)
	if (locale === "de") return de_freebies_meta_title(inputs)
	if (locale === "en-US") return en_us2_freebies_meta_title(inputs)
	if (locale === "es-ES") return es_es2_freebies_meta_title(inputs)
	if (locale === "es-MX") return es_mx2_freebies_meta_title(inputs)
	if (locale === "fil") return fil_freebies_meta_title(inputs)
	if (locale === "fr") return fr_freebies_meta_title(inputs)
	if (locale === "it") return it_freebies_meta_title(inputs)
	if (locale === "hu") return hu_freebies_meta_title(inputs)
	if (locale === "nl") return nl_freebies_meta_title(inputs)
	if (locale === "no") return no_freebies_meta_title(inputs)
	if (locale === "pl") return pl_freebies_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_freebies_meta_title(inputs)
	if (locale === "pt") return pt_freebies_meta_title(inputs)
	if (locale === "ro") return ro_freebies_meta_title(inputs)
	if (locale === "fi") return fi_freebies_meta_title(inputs)
	if (locale === "sv") return sv_freebies_meta_title(inputs)
	if (locale === "vi") return vi_freebies_meta_title(inputs)
	if (locale === "tr") return tr_freebies_meta_title(inputs)
	if (locale === "cs") return cs_freebies_meta_title(inputs)
	if (locale === "bg") return bg_freebies_meta_title(inputs)
	if (locale === "ru") return ru_freebies_meta_title(inputs)
	if (locale === "uk") return uk_freebies_meta_title(inputs)
	if (locale === "ar") return ar_freebies_meta_title(inputs)
	if (locale === "hi") return hi_freebies_meta_title(inputs)
	if (locale === "th") return th_freebies_meta_title(inputs)
	if (locale === "ja") return ja_freebies_meta_title(inputs)
	if (locale === "zh-CN") return zh_cn2_freebies_meta_title(inputs)
	if (locale === "zh-Hant") return zh_hant1_freebies_meta_title(inputs)
	return ko_freebies_meta_title(inputs)
});
export { freebies_meta_title as "freebies.meta.title" }